import create from './5-libs/core';
import modules from './2-tool/modules.jsx';

// 2-tool (utilities)
import './2-tool/Typography';

// 3-generics
import './3-generics/LazyLoadImage';

// 4-helper (helper classes)
import './4-helper/BrowserDetection';
import './4-helper/CheckDevice';
import './4-helper/ConvertSvg';
import './4-helper/UserAgent';
import './4-helper/ADA';
import './4-helper/GravityForm';
import './4-helper/ScrollAnchorLink';
import './4-helper/TableResponsive';

// Components (co-located structure)
import '../../components/animation-page/script.js'
import '../../components/header/scripts/Header.js'
import '../../components/header/scripts/Menu.js'
import '../../components/header/scripts/ADAMenu.js'
import '../../components/header/scripts/SearchLightbox.js'
import '../../components/module-info-settings/script.js'
import '../../components/popup/script.js'
// Modules
import '../../modules/basic/script.js'


document.addEventListener(
  'DOMContentLoaded',
  async () => {
    create(modules);
  },
  false,
);

// Hot reload for start dev.
if (import.meta.hot) {
  console.log('Updated vite');
}